<template>
  <b-button
    class="btn-sm download-report-btn"
    :class="customClass"
    :variant="isMobile ? 'outline-light': 'outline-primary'"
    :disabled="isLoading"
    @click="downloadExcelReport"
  >
    <feather-icon
      :icon="isLoading ? 'LoaderIcon' : 'DownloadIcon'"
      size="22"
      class="align-text-top"
      :class="{ 'spin-icon': isLoading }"
    />
    {{ buttonText }}
  </b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// eslint-disable-next-line import/no-named-as-default
import DeviceService from '@/services/device.service' // Adjust the path as needed

export default {
  name: 'DownloadReportButton',
  components: {
    BButton,
  },
  props: {
    buttonText: {
      type: String,
      default: 'دانلود گزارش',
    },
    customClass: {
      type: String,
      default: 'mb-1 mx-1',
    },
    filter: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      isMobile: false,
    }
  },
  mounted() {
    // Check if Vue.prototype.$functions.isMobile exists and is a function
    if (this.$functions && typeof this.$functions.isMobile === 'function') {
      this.isMobile = this.$functions.isMobile()
    } else {
      // Fallback to a simple check if the function is not available
      this.isMobile = window.innerWidth < 768
    }
  },
  methods: {
    downloadExcelReport() {
      this.isLoading = true

      DeviceService.exportExcel(this.filter)
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'دانلود گزارش',
              text: 'فایل گزارش با موفقیت دانلود شد.',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$emit('download-success')
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطا در دانلود گزارش',
              text: error.message || 'خطایی در دانلود فایل رخ داد.',
              icon: 'XIcon',
              variant: 'danger',
            },
          })
          this.$emit('download-error', error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>

<style scoped>
.download-report-btn {
  transition: all 0.3s ease;
}

.spin-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
